import { resetSubcontractor } from '../State/subcontractor'
import { resetFilters } from '../State/filters'

export default () => (dispatch) => {

  dispatch(resetSubcontractor())
  dispatch(resetFilters())

}
